import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { callingCode, Nationality, slashFormatter } from "../../helpers/helper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  checkEmailAsync,
  getKey,
  getRegisterErrors,
  resetErrors,
  resetKey,
  resetRegisterStatus,
  userRegisterAsync,
} from "../../features/userSlice";
// import { toast } from "react-toastify";
import { errorToast, successToast } from "../../helpers/toaster";
import { useForm } from "../../hooks/useForm";
import { Link } from "react-router-dom";

const RegisterModal = ({ vals }) => {
  const { show, setShow, setModal, extraData } = vals;
  const [showpassowrd, setshowpassowrd] = useState(false);
  const [cshowpassowrd, setCshowpassowrd] = useState(false);
  // const [state, setState] = useState({
  //   FirstName: "",
  //   LastName: "",
  //   Dob: "",
  //   Gender: "",
  //   Email: "",
  //   MobileNo: "",
  //   Nationality: "",
  //   CountryCode: "",
  //   Password: "",
  //   cPassword: "",
  //   tc: false,
  // });

  const emailExist = useSelector(
    (state) => state.user.emailExist,
    shallowEqual
  );
  const errors = useSelector((state) => state.user.errors, shallowEqual);

  const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
  const registerStatus = useSelector(
    (state) => state.user.registerStatus,
    shallowEqual
  );

  const customValidate = (errors) => {
    if (errors?.cPassword !== undefined) {
      errors.cPassword = "Confirm password is required!";
    }

    if (errors?.Dob !== undefined) {
      errors.Dob = "Date of birth is required!";
    }

    if (errors?.cPassword === undefined && state.Password !== state.cPassword) {
      errors.cPassword = "Password must be Same";
    }

    if (
      errors?.MobileNo === undefined &&
      state.MobileNo?.length <= 6 &&
      state.MobileNo?.length >= 10
    ) {
      errors.MobileNo = "Please enter valid number!";
    }

    if (state?.tc === false) {
      errors.tc = "Please agree terms And condition to register";
    }
    return errors;
  };

  const {
    state,
    setState,
    setFormErrors,
    isSubmit,
    formErrors,
    handleInputChange,
    handleFormSubmit,
    checkErrors,
    setIsSubmit,
  } = useForm({
    val: {
      FirstName: "",
      LastName: "",
      Dob: "",
      Gender: "",
      Email: "",
      MobileNo: "",
      Nationality: "",
      CountryCode: "",
      Password: "",
      cPassword: "",
      tc: false,
    },
    inValidate: customValidate,
  });

  const [startDate, setStartDate] = useState(
    new Date().setFullYear(new Date().getFullYear() - 50)
  );
  const [endDate, setEndDate] = useState(
    new Date().setFullYear(new Date().getFullYear() - 5)
  );

  // const [isSubmit, setIsSubmit] = useState(false);
  // const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();
  const backErrors = useSelector(getRegisterErrors);

  const key = useSelector(getKey);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      dispatch(userRegisterAsync(state)); //register dispatch here

      setIsSubmit(false);
    }
  }, [formErrors]);

  // useEffect(() => {

  //   if (backErrors?.errors?.length > 0) {
  //     backErrors?.errors?.map((ele) => {
  //       errorToast(ele.msg);
  //     });
  //     setShow(false);
  //     dispatch(resetErrors());
  //   }
  // }, [backErrors]);

  useEffect(() => {
    if (registerStatus) {
      setShow(false);
      dispatch(resetRegisterStatus());
    }
  }, [registerStatus]);

  const showHidehandler = () => {
    setshowpassowrd(!showpassowrd);
  };
  const showCHidehandler = () => {
    setCshowpassowrd(!cshowpassowrd);
  };

  useEffect(() => {
    if (key !== "") {
      //successToast("User Registered Successfully!");
      //setModal("EmailVarification");
      //setShow(true);
      // dispatch(resetKey());
    }
  }, [key]);

  const handleDatePicker = (e) => {
    let myDate = new Date(e.getTime() - e.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
    setState({ ...state, Dob: myDate });
    delete formErrors["Dob"];
  };

  return (
    <>
      <div
        className={`modal my-auto ${true ? "d-flex" : "d-none"}`}
        id="signup-Modal"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <form action="" className="cmn-form login-form">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setShow(false);
                    extraData(false);
                    setModal("login");
                    setFormErrors({});
                    dispatch(resetErrors());
                  }}
                ></button>
                <div className="form-title">
                  <h2>Welcome to vayosia</h2>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">First name</label>
                      <input
                        type="text"
                        placeholder="Enter First Name"
                        autoComplete="off"
                        name="FirstName"
                        value={state.FirstName}
                        onChange={handleInputChange}
                        onBlur={(e) => checkErrors(e)}
                      />
                      <p className="text-danger">{formErrors?.FirstName}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">Last name</label>
                      <input
                        type="text"
                        placeholder="Enter Last Name"
                        autoComplete="off"
                        name="LastName"
                        value={state.LastName}
                        onChange={handleInputChange}
                        onBlur={(e) => checkErrors(e)}
                      />
                      <p className="text-danger">{formErrors?.LastName}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">Date of birth</label>
                      <DatePicker
                        onChange={handleDatePicker}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        selected={Date.parse(state.Dob)}
                        dropdownMode="select"
                        minDate={startDate}
                        maxDate={endDate}
                        dateFormat="yyyy/MM/dd"
                        name="Dob"
                        placeholderText="Date of birth"
                        //value={ state.Dob}
                        value={
                          state.Dob !== "" ? slashFormatter(state.Dob) : ""
                        }
                        onBlur={(e) => checkErrors(e)}
                        className={`form-control ${
                          formErrors.Dob && "form-control-danger"
                        }`}
                        style={{ Zindex: "100" }}
                      />
                      <p className="text-danger">{formErrors?.Dob}</p>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group position-relative">
                      <div className="select-arrow"></div>
                      <label htmlFor="">Gender</label>
                      <select
                        name="Gender"
                        onChange={handleInputChange}
                        onBlur={(e) => checkErrors(e)}
                      >
                        <option value="">Select Gender</option>
                        {["Male", "Female", "Others"].map((ele, ind) => (
                          <option value={ele} key={ind}>
                            {ele}
                          </option>
                        ))}
                      </select>
                      <p className="text-danger">{formErrors?.Gender}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">Email</label>
                      <input
                        type="Email"
                        placeholder="Enter Email"
                        autoComplete="off"
                        name="Email"
                        value={state.Email}
                        onChange={handleInputChange}
                        onBlur={(e) => {
                          checkErrors(e);
                          emailRegex.test(e.target.value) &&
                            dispatch(checkEmailAsync(e.target.value));
                        }}
                      />
                      {errors?.Email === "Email already exist!!!" && (
                        <p className="text-danger">{errors?.Email}</p>
                      )}
                      <p className="text-danger">{formErrors?.Email}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mobile-number">
                      <div className="form-group">
                        <label for="">Mobile Number </label>
                        <div>
                          <div className="position-relative select-country-code">
                            <div className="select-arrow"></div>
                            <select
                              name="CountryCode"
                              onChange={handleInputChange}
                              onBlur={(e) => checkErrors(e)}
                            >
                              <option value=""> Code</option>
                              {callingCode.map((ele, ind) => (
                                <option key={ind} value={ele.value}>
                                  {ele.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <input
                            type="text"
                            placeholder="Enter Mobile Number"
                            autoComplete="off"
                            name="MobileNo"
                            value={state.MobileNo}
                            onChange={handleInputChange}
                            onBlur={(e) => checkErrors(e)}
                          />
                        </div>
                        <p className="text-danger inline-block">
                          {formErrors?.CountryCode}
                        </p>
                        <p className="text-danger inline-block">
                          {formErrors?.MobileNo}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group position-relative">
                      <div className="select-arrow"></div>
                      <label htmlFor="">Nationality</label>
                      <select
                        name="Nationality"
                        onChange={handleInputChange}
                        onBlur={(e) => checkErrors(e)}
                      >
                        <option value="">Select Nationality</option>
                        {Nationality.map((ele, ind) => (
                          <option key={ind} value={ele.value}>
                            {ele.label}
                          </option>
                        ))}
                      </select>
                      <p className="text-danger">{formErrors?.Nationality}</p>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group position-relative">
                      <div className="eye-paassword"></div>
                      <label htmlFor="Password">Password</label>
                      <input
                        type={showpassowrd ? "text" : "password"}
                        className="form-control"
                        name="Password"
                        placeholder="Enter Password"
                        value={state.Password}
                        onChange={handleInputChange}
                        onBlur={(e) => checkErrors(e)}
                      />
                      <span className="password" onClick={showHidehandler}>
                        <i
                          className={
                            showpassowrd ? "fas fa-eye" : "fas fa-eye-slash"
                          }
                        ></i>
                      </span>
                      <p className="text-danger">{formErrors?.Password}</p>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group  position-relative">
                      <div className="eye-paassword"></div>
                      <label htmlFor="cPassword">Confirm Password</label>
                      <input
                        type={cshowpassowrd ? "text" : "password"}
                        className="form-control"
                        id="cPassword"
                        name="cPassword"
                        placeholder="Enter Confirm Password"
                        value={state.cPassword}
                        onChange={handleInputChange}
                        onBlur={(e) => checkErrors(e)}
                      />
                      <span className="password" onClick={showCHidehandler}>
                        <i
                          className={
                            cshowpassowrd ? "fas fa-eye" : "fas fa-eye-slash"
                          }
                        ></i>
                      </span>
                      <p className="text-danger">{formErrors?.cPassword}</p>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="check1"
                          className="form-check-input"
                          defaultChecked={state.tc}
                          name="tc"
                          onBlur={(e) => checkErrors(e)}
                          onClick={() => setState({ ...state, tc: !state.tc })}
                        />
                        <label className="form-check-label">
                          <Link to="/terms" target="_blank">
                            Agree terms and condition
                          </Link>
                        </label>
                        <p className="text-danger">{formErrors?.tc}</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group">
                      <input
                        disabled={
                          errors?.Email === "Email already exist!!!" && true
                        }
                        type="submit"
                        className="cmn-btn form-btn"
                        value="Signup"
                        onClick={handleFormSubmit}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="text-center">
                      <p className="already-member">
                        Already a member? Login{" "}
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#loginModal"
                          onClick={() => {
                            dispatch(resetErrors());
                            setModal("login");
                          }}
                        >
                          here
                        </a>{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterModal;
